import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title:
    "Mental Health Treatment for First Responders | Neuro Wellness TMS Centers of America",
  description:
    "First responders: comprehensive mental health treatment options including TMS, SAINT, SPRAVATO, ketamine, and therapy for depression, anxiety, and PTSD.",
  canonical: "/mental-health-treatment-for-first-responders",
  keywords:
    "first responder mental health treatment, first responder depression treatment Florida, first responder PTSD treatment, first responder TMS therapy",
};

const relatedLinks = [
  { title: "TMS for First Responders", href: "/tms-for-first-responders" },
  {
    title: "Depression Treatment for First Responders",
    href: "/depression-treatment-for-first-responders",
  },
  {
    title: "First Responder Insurance Verification",
    href: "/first-responder-insurance-verification",
  },
  { title: "PTSD and TMS", href: "/services/ptsd" },
];

export default function MentalHealthTreatmentForFirstResponders() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="First Responder Mental Health"
      title="Mental Health Treatment for First Responders"
      subtitle="Comprehensive treatment options for first responders experiencing depression, anxiety, PTSD, or other mental health conditions."
    >
      <DecisionSection heading="Why specialized care matters">
        <p>
          First responders need mental health care from providers who understand
          the culture, the language, and the reality of the work. Generic
          therapy that doesn't account for shift work, trauma exposure, and the
          stigma within first responder communities often doesn't reach people
          effectively.
        </p>
        <p>
          At Neuro Wellness TMS Centers of America, we offer advanced treatments
          that go beyond standard medication management — including TMS, SAINT
          accelerated TMS, SPRAVATO, ketamine, and specialized therapy.
        </p>
      </DecisionSection>

      <DecisionSection heading="Conditions we treat">
        <DecisionList
          items={[
            "Depression — including treatment-resistant depression",
            "Anxiety — including generalized anxiety and panic disorder",
            "PTSD — including chronic PTSD from repeated trauma exposure",
            "Suicidal ideation — acute and chronic",
            "Bipolar depression — in coordination with your prescriber",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Treatment options">
        <DecisionList
          items={[
            "TMS — FDA-cleared, non-invasive, outpatient",
            "SAINT accelerated TMS — five-day protocol, FDA-cleared",
            "SPRAVATO (esketamine) — FDA-approved for TRD and MDD with suicidal thoughts",
            "Prism for PTSD — EEG neurofeedback for PTSD",
            "IV ketamine and KAP",
            "Trauma-informed psychotherapy — CBT, EMDR, DBT",
            "Medication management",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Your next step">
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link
            to="/first-responder-insurance-verification"
            className="text-accent hover:underline"
          >
            verify your insurance
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
